const DEFAULT_SCORING_HISTORY_DATA = { loading: true, loaded: false, scoringSessionsHistory: [] };

const getDocumentScoringHistorySessionsFlags = (state, key) => state.document.scoringHistoryData[key];

export const getScoringHistory = (state, key) => {
  const flags = getDocumentScoringHistorySessionsFlags(state, key);

  if (!flags || !flags.loaded || flags.loading) return DEFAULT_SCORING_HISTORY_DATA;

  const scoringSessionsHistory = state.entities.scoringHistory.scoringSessions[key];
  return {
    scoringSessionsHistory: Object.assign([], Object.values(scoringSessionsHistory || {})),
    loaded: flags.loaded,
    loading: flags.loading
  };
};

export const getScoringGridsHistory = (state, key, sessionID) => {
  const scoringSessionsHistory = state.entities.scoringHistory.scoringSessions[key];

  if (
    !scoringSessionsHistory ||
    !scoringSessionsHistory[sessionID] ||
    !state.entities.scoringHistory.scoringSessionsGrids[sessionID]
  )
    return [];

  return state.entities.scoringHistory.scoringSessionsGrids[sessionID];
};
